/* ============================================================
   CPFS category pages — floating brand filter dock.
   The brand jump-chips live in the collection hero (.v3-anchors).
   When they scroll out of view, a clone floats in at the bottom
   centre of the viewport (.v3-brand-dock) so the filter stays
   reachable down the page. Progressive enhancement: without JS the
   hero chips still work. Ported from phase-one js/brand-dock.js;
   loaded only by cpfs-collection-hero (self-gates on .v3-anchors).
   ============================================================ */
(function () {
  'use strict';

  var anchors = document.querySelector('.v3-page-hero .v3-anchors');
  if (!anchors) return;

  /* A one-brand category (e.g. Tomato) has nothing to filter; a
     floating dock with a single chip is just noise. */
  if (anchors.querySelectorAll('.v3-anchor').length < 2) return;

  var dock = document.createElement('nav');
  dock.className = 'v3-brand-dock';
  dock.setAttribute('aria-label', 'Jump to brand');
  dock.innerHTML = anchors.innerHTML;

  /* Chips colour their hover from --cat, set on the hero section. */
  var catSource = anchors.closest('[style*="--cat"]');
  if (catSource) dock.style.cssText = catSource.getAttribute('style');

  document.body.appendChild(dock);

  /* Plain scroll listener rather than IntersectionObserver: one
     getBoundingClientRect per frame, and it keeps working in
     throttled/background tabs. */
  function update() {
    var visible = anchors.getBoundingClientRect().bottom < 0;
    dock.classList.toggle('is-visible', visible);
    document.body.classList.toggle('has-brand-dock', visible);
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();
